// extracted by mini-css-extract-plugin
module.exports = {"Loading":"MapCanvas_Loading__13uZl","slide":"MapCanvas_slide__2ysdh","Error":"MapCanvas_Error__74Wr6"};